import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import localReducer from "./slices/localSlice";
import storageReducer from "./slices/storageSlice";
import firestoreReducer from "./slices/firestoreSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    local: localReducer,
    storage: storageReducer,
    firestore: firestoreReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
